document.addEventListener("DOMContentLoaded", () => {
  const boxContainers = document.querySelectorAll(".bc");

  if (!boxContainers.length) return;

  const resizeBoxes = () => {
    boxContainers.forEach((container) => {
      const boxes = container.querySelectorAll(".b");

      const heights = Array.from(boxes).map((box) => box.offsetHeight);
      const maxHeight = Math.max(...heights);

      boxes.forEach((box) => {
        box.style.height = `${maxHeight}px`;
        box.style.maxHeight = "unset";
      });
    });
  };

  window.addEventListener("resize", resizeBoxes);
  resizeBoxes();
});
